var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#0000FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.564 15.644C10.092 15.644 9.64 15.556 9.208 15.38C8.784 15.204 8.416 14.956 8.104 14.636C7.8 14.308 7.592 13.92 7.48 13.472L8.896 12.968C9.032 13.376 9.252 13.68 9.556 13.88C9.86 14.072 10.196 14.168 10.564 14.168C10.868 14.168 11.136 14.104 11.368 13.976C11.608 13.84 11.792 13.656 11.92 13.424C12.048 13.184 12.112 12.908 12.112 12.596C12.112 12.284 12.044 12.012 11.908 11.78C11.78 11.548 11.6 11.368 11.368 11.24C11.136 11.104 10.868 11.036 10.564 11.036C10.252 11.036 9.968 11.104 9.712 11.24C9.464 11.376 9.284 11.572 9.172 11.828L7.84 11.528L8.548 6.56H13.42V7.94H9.196L9.808 7.232L9.304 10.976L8.836 10.592C9.06 10.264 9.332 10.024 9.652 9.872C9.98 9.72 10.376 9.644 10.84 9.644C11.432 9.644 11.944 9.772 12.376 10.028C12.816 10.284 13.156 10.632 13.396 11.072C13.636 11.512 13.756 12.02 13.756 12.596C13.756 13.172 13.616 13.692 13.336 14.156C13.056 14.62 12.676 14.984 12.196 15.248C11.716 15.512 11.172 15.644 10.564 15.644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber5);
export default __webpack_public_path__ + "static/media/number5.01f4be519662c5b5dec02a27e710f7ed.svg";
export { ForwardRef as ReactComponent };